import type { MenuOptionType } from "@dexteel/mesf-core";
import { ArrowDownward as ArrowDownwardIcon } from "@mui/icons-material";
import { ArrowUpward as ArrowUpwardIcon } from "@mui/icons-material";
import { Delete as DeleteIcon } from "@mui/icons-material";
import { Edit as EditIcon } from "@mui/icons-material";
import { FindInPage as FindInPageIcon } from "@mui/icons-material";
import { PlaylistAdd as PlaylistAddIcon } from "@mui/icons-material";
import type { Dispatch, SetStateAction } from "react";
import type { TreeParameters } from "../../models/TreeParameter";
import type { DelayCodeLabels } from "../../delayCodeLabels";

interface Props {
  setDelayCodeId: Dispatch<SetStateAction<number | null | undefined>>;
  setShowModal: (modal: "create" | "update" | "delete" | "view" | "") => void;
  handleMoveUp: ({ delayCodeId }: { delayCodeId: number }) => void;
  handleMoveDown: ({ delayCodeId }: { delayCodeId: number }) => void;
  labels: DelayCodeLabels;
}

export const useDelayCodeOptionsFunctions = ({
  setDelayCodeId,
  setShowModal,
  handleMoveUp,
  handleMoveDown,
  labels,
}: Props) => {
  const getMenuOptions = (data: TreeParameters) => {
    let options: MenuOptionType[] = [];
    options = options.concat([
      {
        name: `New ${labels.singular}`,
        key: "new_delay_code",
        onClick: () => {
          setShowModal("create");
        },
        icon: <PlaylistAddIcon />,
      },
    ]);
    if (data) {
      options = options.concat([
        {
          name: `Edit ${labels.singular}`,
          key: "edit_delay_code",
          onClick: () => {
            setDelayCodeId(data.id);
            setShowModal("update");
          },
          icon: <EditIcon />,
        },
        {
          name: `View ${labels.singular}`,
          key: "view_delay_code",
          onClick: () => {
            setDelayCodeId(data.id);
            setShowModal("view");
          },
          icon: <FindInPageIcon />,
        },
      ]);
      if (!data.droppable) {
        options = options.concat([
          {
            name: `Delete ${labels.singular}`,
            key: "delete_delay_code",
            onClick: () => {
              setDelayCodeId(data.id);
              setShowModal("delete");
            },
            icon: <DeleteIcon />,
          },
          {
            name: "Move Up",
            key: "move_up_delay_code",
            disabled: data.isAtTop,
            onClick: () => {
              handleMoveUp({ delayCodeId: data.id });
            },
            icon: <ArrowUpwardIcon />,
          },
          {
            name: "Move Down",
            key: "move_down_delay_code",
            disabled: data.isAtBottom,
            onClick: () => {
              handleMoveDown({ delayCodeId: data.id });
            },
            icon: <ArrowDownwardIcon />,
          },
        ]);
      }
    }
    return options;
  };
  return {
    getMenuOptions,
  };
};
